import FilterChipMixin from './mixin.js';

const Option = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      return this.filter.value.value;
    }
  }
};

export {
  Option as YAW__AssignmentDurationThresholdFilterChip
};
